export { default } from './ImageAndTextCheckQuestionContainer';
